import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Path } from "../../constants/path";
import NotFoundScreen from "../other/NotFoundScreen";
import IndexScreen from "./IndexScreen";

class BaseScreen extends PureComponent {
  render = () => {
    return (
      <Switch>
        <Route exact path={Path.news.url} component={IndexScreen} />
        <Route component={NotFoundScreen} />
      </Switch>
    );
  };
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({}, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BaseScreen),
);
